import type { Dtos } from "@inrev/common";
import { Option } from "@inrev/core";
import { FC } from "react";
import { StatBlock } from "./StatBlock";

type Report = Dtos.Admin.SuretyAccount.Get.Response["companies"][number]["creditReports"][number];

type UccFilingsPanelProps = {
	report: Report;
};

export const UccFilingsPanel: FC<UccFilingsPanelProps> = ({ report }) => {
	const elements = report.creditProfile?.experianExecutiveElements;
	const filings = elements?.uccFilings;
	const derog = elements?.uccDerogatoryCount;

	const summary: string[] = [];
	if (Option.isSome(filings)) {
		summary.push(`${filings} on file`);
	}
	if (Option.isSome(derog)) {
		summary.push(`${derog} derogatory`);
	}

	return (
		<div
			className="space-y-3 border-b border-bc-default pb-5"
			data-amp-mask
			data-testid="company_credit_ucc_panel"
		>
			<div className="flex flex-wrap items-baseline justify-between gap-2">
				<h3 className="text-[15px] font-medium text-primary">UCC Filings</h3>
				{summary.length > 0 && (
					<span className="text-secondary text-[13px]">{summary.join(" · ")}</span>
				)}
			</div>
			<div className="grid grid-cols-2 gap-3 md:grid-cols-4">
				<StatBlock label="UCC Filings" value={filings} />
				<StatBlock label="Derogatory UCC" value={derog} />
				<StatBlock label="Earliest Filing" value={elements?.earliestUccDate} />
				<StatBlock label="Most Recent" value={elements?.mostRecentUccDate} />
			</div>
		</div>
	);
};
